module.exports = __webpack_public_path__ + "static/media/twitter.3f63ee49.svg";